export const getCategoryKeyFromUri = (uri: string) => uri.toUpperCase().replace(/-/g, '_');
